import React from 'react';
import StaticPage from '../components/common/StaticPage';

const TermsAndConditions = () => (
  <StaticPage title="Terms & Conditions">
{`Welcome to TechVahini.

- The content provided is for educational purposes. Results may vary.
- You agree not to misuse the website or attempt to disrupt its operation.
- Links to third-party sites (e.g., YouTube) are provided for convenience.

By using this site, you accept these terms.`}
  </StaticPage>
);

export default TermsAndConditions;
